import { childrenBusinessPageBreadcrumbs } from '../../config';
import { useArrivalScanning, useScannerFocus } from './hooks';
import { LoaderBackdrop, NavigateLinks } from '@/components';
import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import React from 'react';
import {
  ArrivalScanPanel,
  ResultOverlay,
  ScannedItemsList,
  ConcludeScan,
} from './components';

const ArrivalScanning: React.FC = () => {
  const navigate = useNavigate();
  const [isConcluding, setIsConcluding] = useState(false);

  const breadcrumbs = useMemo(
    () => childrenBusinessPageBreadcrumbs(navigate),
    [navigate]
  );

  const {
    code,
    scannedItems,
    setCode,
    lastResult,
    error,
    failedShippingNumber,
    showOverlay,
    setShowOverlay,
    inputRef,
    isLoading,
    onKeyDown,
    clearScannedItems,
  } = useArrivalScanning();

  useScannerFocus(inputRef, true);

  const handleConclude = () => {
    setIsConcluding(true);
    setTimeout(() => {
      clearScannedItems();
      setIsConcluding(false);
    }, 1500);
  };

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <NavigateLinks
        actualPage='Escaneo de Arribos'
        breadcrumbs={breadcrumbs}
      />

      <section className='w-full h-full flex flex-col items-start'>
        <div className='w-full flex flex-col gap-8'>
          <ArrivalScanPanel
            inputValue={code}
            setInputValue={setCode}
            onKeyDown={onKeyDown}
            isLoading={isLoading}
            inputRef={inputRef}
          />

          <ScannedItemsList items={scannedItems} />

          <ConcludeScan
            onConclude={handleConclude}
            disabled={scannedItems.length === 0 || isLoading || isConcluding}
          />
        </div>
      </section>

      <ResultOverlay
        show={showOverlay}
        result={lastResult}
        error={error}
        failedShippingNumber={failedShippingNumber}
        onClose={() => {
          setShowOverlay(false);
          setTimeout(() => inputRef.current?.focus(), 50);
        }}
      />

      {(isLoading || isConcluding) && <LoaderBackdrop />}
    </section>
  );
};

export default ArrivalScanning;
